import { render, staticRenderFns } from "./DwellTimeParameterTable.vue?vue&type=template&id=2d6ed461"
import script from "./DwellTimeParameterTable.vue?vue&type=script&lang=js"
export * from "./DwellTimeParameterTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports